import Form from '@/components/organisms/Auth/Login/FormWhiteLabel'

export function LoginPage() {
	return <Form />
}
